/**
 * Consigned Inventory - static configuration (SCAFFOLD)
 *
 * TODO(team): replace hard-coded labels with i18n keys (t('...')) and
 * feed columns / search types from the API contract once available.
 */

// Search-type dropdown options (screenshot shows "Lot/Serial #").
export const CONSIGNED_SEARCH_TYPE_OPTIONS = [
    { label: 'reportUsage.itemList.lotSerialInputPlaceHolder.lotOrSerial', code: 'batch' },
    { label: 'receiveSets.InventoryConsigned.cfn', code: 'cfn' }
];

// Placeholder text per search type (used in the search box).
export const CONSIGNED_SEARCH_PLACEHOLDERS = {
    lotSerial: 'Lot or Serial #',
    cfn: 'CFN',
    account: 'Account',
};

// Table column definition. `field` maps to a row property from the API.
export const CONSIGNED_TABLE_COLUMNS = [
    { id: 'account', label: 'Account', field: 'account', sortable: true },
    { id: 'cfn', label: 'CFN', field: 'cfn', sortable: true },
    { id: 'description', label: 'Description', field: 'materialDesc', sortable: true },
    { id: 'lotSerial', label: 'Lot/Serial', field: 'lotSerial', sortable: true },
    { id: 'onHand', label: 'On Hand', field: 'onHand' },
    { id: 'useByDate', label: 'Use by Date', field: 'sled', sortable: true },
];

// Placeholder rows so the table renders during scaffolding.
// TODO(team): remove once wired to the consigned inventory API.
export const CONSIGNED_PLACEHOLDER_ROWS = Array.from(
    { length: 11 },
    (_, index) => ({
        id: index,
        account: '0002223063 UNC Surgical Hospital',
        cfn: '7509225',
        materialDesc: 'Trial 1000-4605 tc 6 deg md 5mm',
        lotSerial: 'A70267-014',
        onHand: '1',
        useByDate: '04/16/2027',
        expiryStatus: 'EXPIRED',
    })
);
